import { render, staticRenderFns } from "./BillingFare.vue?vue&type=template&id=1ff55ccf&scoped=true"
import script from "./BillingFare.vue?vue&type=script&lang=js"
export * from "./BillingFare.vue?vue&type=script&lang=js"
import style0 from "./BillingFare.vue?vue&type=style&index=0&id=1ff55ccf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff55ccf",
  null
  
)

export default component.exports